export class MakeMoovStep {
    num: number;
    constructor(num: number) {
        this.num = num;
    }
}
